/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Gmail_Ingest_AttachmentsInputs */

const es_tools_gmail_ingest_attachments = /** @type {(inputs: Tools_Gmail_Ingest_AttachmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingestando adjuntos de Gmail...`)
};

const en_tools_gmail_ingest_attachments = /** @type {(inputs: Tools_Gmail_Ingest_AttachmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingesting Gmail attachments...`)
};

/**
* | output |
* | --- |
* | "Ingesting Gmail attachments..." |
*
* @param {Tools_Gmail_Ingest_AttachmentsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_gmail_ingest_attachments = /** @type {((inputs?: Tools_Gmail_Ingest_AttachmentsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Gmail_Ingest_AttachmentsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_gmail_ingest_attachments(inputs)
	return en_tools_gmail_ingest_attachments(inputs)
});
export { tools_gmail_ingest_attachments as "tools.gmail.ingest_attachments" }